<div class="notification-background"
     adaptTooltip="Recent activities{{ unreadCountText ? ' (' + unreadCountText + ' unread)' : '' }}">
    <i class="notification-bell fas fa-bell"></i>
    @if (unreadCountText) {
        <span class="notification-badge">{{ unreadCountText }}</span>
    }
</div>
